import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function Navbar() {
  return (
    <motion.header
      initial={{ y: -64, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 inset-x-0 z-50 bg-[#FAF9F6]/80 backdrop-blur-xl border-b border-[#0F172A]/5"
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 h-16 sm:h-20 flex items-center justify-between">
        <a href="/" data-testid="header-logo" className="flex items-center gap-2.5">
          <img src="/logo-horse.png" alt="Kobi-Line" className="w-9 h-9 rounded-xl object-cover shadow-lg shadow-[#0000FF]/25" />
          <span className="font-display font-bold text-lg tracking-tight">
            KOBİ<span className="text-[#0000FF]">-</span>LİNE
          </span>
        </a>
        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-[#475569]">
          <a href="#surec" data-testid="nav-process-link" className="hover:text-[#0F172A] transition-colors">Süreç</a>
          <a href="#durum" data-testid="nav-status-link" className="hover:text-[#0F172A] transition-colors">Durum Sorgula</a>
          <a href="#form" data-testid="nav-form-link" className="hover:text-[#0F172A] transition-colors">Ön Analiz Formu</a>
        </nav>
        <a
          href="#form"
          data-testid="nav-cta-button"
          className="group inline-flex items-center gap-1.5 rounded-full bg-[#0F172A] text-white text-sm font-semibold px-5 py-2.5 transition-colors hover:bg-[#0000FF]"
        >
          Hemen Başvur
          <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      </div>
    </motion.header>
  );
}
